import axios from "axios";
import AppConfig from "../config";
import { hasValue } from "../utils/commonFns";

const baseURL = `${AppConfig.API_URL}/RiderMatrix`;

const getRider = async (nameFilter) => {
  try {
    var url = `${baseURL}?`;
    if (hasValue(nameFilter)) url += `name=${nameFilter}&`;
    let { data } = await axios.get(`${url}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const getRiderById = async (id) => {
  try {
    let { data } = await axios.get(`${baseURL}/${id}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const addRider = async (rider) => {
  try {
    //let { data } = await axios.post(`${baseURL}`, JSON.stringify(org));

    let { data } = await axios.post(`${baseURL}`, rider, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const updateRider = async (rider) => {
  try {
    // let { data } = await axios.put(`${baseURL}`, JSON.stringify(org));
    let { data } = await axios.put(`${baseURL}`, rider, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const deleteRider = async (id) => {
  try {
    let { data } = await axios.delete(`${baseURL}/${id}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

export { getRider, getRiderById, addRider, updateRider, deleteRider };
